import axios from 'axios';
import { put, call, takeLeading } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import {
    issue_control_create, issue_control_all, issue_control_active,
    issue_control_stats, issue_control_by_id, issue_control_change_status,
    issue_control_add_comment
} from '../../utils/api-routes';

function* getIssuesSaga(action) {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const params = action?.payload || {};
        const queryStr = new URLSearchParams(params).toString();
        const { data } = yield call(axios.get, api_urls + issue_control_all + (queryStr ? '?' + queryStr : ''));
        if (data?.status) {
            yield put({ type: actionTypes.SET_ISSUES, payload: { issues: data?.results, pagination: data?.pagination } });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Issues Saga Error:", error);
    }
}

function* getActiveIssuesSaga() {
    try {
        const { data } = yield call(axios.get, api_urls + issue_control_active);
        if (data?.status) {
            yield put({ type: actionTypes.SET_ACTIVE_ISSUES, payload: data?.results });
        }
    } catch (error) {
        console.log("Get Active Issues Saga Error:", error);
    }
}

function* getIssueByIdSaga(action) {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, api_urls + issue_control_by_id(action?.payload));
        if (data?.status) {
            yield put({ type: actionTypes.SET_ISSUE_BY_ID, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Issue By ID Saga Error:", error);
    }
}

function* getIssueStatsSaga() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, api_urls + issue_control_stats);
        if (data?.status) {
            yield put({ type: actionTypes.SET_ISSUE_STATS, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Issue Stats Saga Error:", error);
    }
}

function* createIssueSaga(action) {
    try {
        const { payload } = action;
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.post, api_urls + issue_control_create, payload?.data);
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        if (data?.status) {
            Swal.fire({ icon: "success", title: "Issue Created Successfully", text: `Issue ID: ${data?.results?.issueId}`, showConfirmButton: true, timer: 3000 });
            if (payload?.onComplete) yield call(payload.onComplete);
        }
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        Swal.fire({ icon: "error", title: "Failed To Create Issue", text: error?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
        console.log("Create Issue Saga Error:", error?.response?.data);
    }
}

function* changeIssueStatusSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield call(axios.put, api_urls + issue_control_change_status(payload?.id), payload?.data);
        if (data?.status) {
            Swal.fire({ icon: "success", title: "Status Changed Successfully", showConfirmButton: false, timer: 2000 });
            yield put({ type: actionTypes.GET_ISSUE_BY_ID, payload: payload?.id });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Failed To Change Status", text: error?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
        console.log("Change Status Saga Error:", error?.response?.data);
    }
}

function* addIssueCommentSaga(action) {
    try {
        const { payload } = action;
        const { data } = yield call(axios.post, api_urls + issue_control_add_comment(payload?.id), payload?.data);
        if (data?.status) {
            Swal.fire({ icon: "success", title: "Comment Added", showConfirmButton: false, timer: 1500 });
            yield put({ type: actionTypes.GET_ISSUE_BY_ID, payload: payload?.id });
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: "Failed To Add Comment", text: error?.response?.data?.message || "Something went wrong", showConfirmButton: false, timer: 2000 });
        console.log("Add Comment Saga Error:", error?.response?.data);
    }
}

export default function* issueSaga() {
    yield takeLeading(actionTypes.GET_ISSUES, getIssuesSaga);
    yield takeLeading(actionTypes.GET_ACTIVE_ISSUES, getActiveIssuesSaga);
    yield takeLeading(actionTypes.GET_ISSUE_BY_ID, getIssueByIdSaga);
    yield takeLeading(actionTypes.GET_ISSUE_STATS, getIssueStatsSaga);
    yield takeLeading(actionTypes.CREATE_ISSUE, createIssueSaga);
    yield takeLeading(actionTypes.CHANGE_ISSUE_STATUS, changeIssueStatusSaga);
    yield takeLeading(actionTypes.ADD_ISSUE_COMMENT, addIssueCommentSaga);
}
